import { useMutation } from "@apollo/client";

import { CreatePaymentMethodDocument } from "../../__generated__/graphql";

export function useCreatePaymentMethod() {
  return useMutation(CreatePaymentMethodDocument, {
    refetchQueries: ["ClientPaymentMethod"],
    awaitRefetchQueries: true,
  });
}
